'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _primitives = require('../primitives');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderErrorField = function renderErrorField(type) {
  return function (props) {
    return props.error ? _react2.default.createElement(
      _primitives.Text,
      null,
      props.error
    ) : _react2.default.createElement(_primitives.View, null);
  };
};

exports.default = renderErrorField;